module.exports = __webpack_public_path__ + "static/media/true-north-background.bc5f5c56.jpg";